<script>
import {  common } from '@/mixins/common';
import { 
  GetApiActionWithAuthorization, 
  PostApiWithAuthorizationAction
} from '../../../helpers/apiActions';
import moment from "moment-timezone";

export default {
  name: 'ScanFormDialog',
  components: {},
  props: {
    displayDialog: {
      type: Boolean,
      required: true
    },
    pageViewTagId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
        displayScanHistoryDialog: false,
        form: {
            shipDate: new Date(),
            scanFormGenerateType: 'date'
        },
        fileUrl: ''
    }
  },
  mixins: [
    common
  ],
  methods: {
    handleDialogClose() {
      this.$root.$emit('close-dialog', 'displayScanFormDialog')
    },
    viewScanHistory() {
      this.displayScanHistoryDialog = true
    },
    setScanFormGenerateType(type) {
      this.form.scanFormGenerateType = type
    },
    submitForm() {
      const _vm = this
      PostApiWithAuthorizationAction("admin/orders/create-scan-form", {
        ... _vm.form,
        pageViewMode: _vm.pageViewTagId
      })
      .then(res => {
        if (res.status == 'success') {
          //open scan form in new tab
          // eslint-disable-next-line
          if (res.hasOwnProperty('scanFormUrl')) {
            window.open(res.scanFormUrl, "_blank");
          }
          //
          _vm.format.shipDate = ''
          _vm.$toast.success(res.message, {
            position: "top-right",
            timeout: 3000,
            closeOnClick: true
          });
        } else {
          _vm.$toast.error(res.message, {
            position: "top-right",
            timeout: 3000,
            closeOnClick: true
          });
        }
      })
    },
    checkPrintedStatus(date) {
      const _vm = this
      GetApiActionWithAuthorization("admin/orders/check-scan-form", {
        date: moment(date).format('YYYY-MM-DD')
      }).then(res => {
        _vm.fileUrl = (res.data) ? res.data.fileName : ''
      })
    },
    downloadFile() {
      window.open(this.fileUrl, "_blank");
    }
  },
  watch: {
    'pageViewTagId': function() {
      setTimeout(function() {
        this.$refs.scanFormShipDate.focus()
      }, 200)
    },
    'form.shipDate': function(val) {
      this.checkPrintedStatus(val)
    }
  }
}
</script>

<template>
    <el-dialog
      custom-class="el-dialog-bs-info el-dialog-label-preview"
      :visible.sync="displayDialog"
      width="35%"
      @close="handleDialogClose">
      <span slot="title"><h5><i class="bx bx-barcode"></i> MANAGE SCAN FORM</h5></span>
        <div class="text-center">
            <el-button
              type="primary"
              class="mb-2"
              @click="viewScanHistory()">
              <i class="fas fa-shopping-cart"></i> SCANS HISTORY
            </el-button>
        </div>
        <div class="box-section mb-3 pb-1">
            <div class="box-section-header">PRINT SCAN FORM</div>
            <div class="box-section-body pt-0">
                <!--div class="text-center">
                    <el-button-group>
                        <el-button
                            type="primary"
                            plain
                            :class="{ 'is-selected': form.scanFormGenerateType === 'date' }"
                            @click="setScanFormGenerateType('date')">SCAN FORM BY DATE</el-button>
                        <el-button
                            type="primary"
                            :class="{ 'is-selected': form.scanFormGenerateType === 'id' }"
                            @click="setScanFormGenerateType('id')"
                            plain>SCAN FORM BY ID</el-button>
                    </el-button-group>
                </div-->
                <div>
                    <div class="text-center mt-2">
                        <el-date-picker
                            v-model="form.shipDate"
                            ref="scanFormShipDate"
                            type="date"
                            style="width: 80%"
                            placeholder="Choose Date"></el-date-picker>
                    </div>
                    <div
                      class="dialog-footer text-center pb-0 pt-2"
                      v-if="fileUrl===''">
                        <el-button
                          type="success"
                          class="mb-1"
                          @click="submitForm()">PRINT</el-button>
                    </div>
                    <div
                      class="dialog-footer text-center pb-0 pt-2"
                      v-else>
                        <el-button
                          type="success"
                          class="mb-1"
                          @click="downloadFile()">DOWNLOAD</el-button>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<style>
    .el-dialog-label-preview {
        margin-top: 3vh !important;
    }
    .el-button.is-selected {
        color: #FFF;
        background-color: #409EFF;
        border-color: #409EFF;
    }
    .el-date-editor.el-input--prefix .el-input__inner {
        padding-left: 30px !important;
    }
</style>
